import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";
import {
  CUSTOMER_ACCESS_STATUS_OPTIONS,
  DEFAULT_CUSTOMER_ACCESS_STATUS_LABEL,
  normalizeCustomerAccessStatus,
} from "common/Constants/AccessStatus.constants";
import {
  AccessStatusChipRoot,
  AccessStatusOptionButton,
  AccessStatusSelectRoot,
  AccessStatusVisuallyHiddenLabel,
  NEUTRAL_CHIP_PALETTE,
  STATUS_CHIP_PALETTES,
} from "./AccessStatusSelect.styles";

const resolveChipPalette = (status) => {
  const key = normalizeCustomerAccessStatus(status);
  if (key && STATUS_CHIP_PALETTES[key]) {
    return { key, palette: STATUS_CHIP_PALETTES[key] };
  }
  return { key: key || "", palette: NEUTRAL_CHIP_PALETTE };
};

export const AccessStatusChip = ({ status }) => {
  const { key, palette } = resolveChipPalette(status);
  const label = key || "—";
  return (
    <AccessStatusChipRoot label={label} size="small" $palette={palette} />
  );
};

AccessStatusChip.propTypes = {
  status: PropTypes.string,
};

AccessStatusChip.defaultProps = {
  status: "",
};

const AccessStatusSelect = ({
  value,
  disabled,
  onChange,
  options = CUSTOMER_ACCESS_STATUS_OPTIONS,
  label = DEFAULT_CUSTOMER_ACCESS_STATUS_LABEL,
  labelId,
}) => {
  const current = normalizeCustomerAccessStatus(value) || "Invited";

  return (
    <AccessStatusSelectRoot>
      {labelId ? (
        <AccessStatusVisuallyHiddenLabel component="span" id={labelId}>
          {label}
        </AccessStatusVisuallyHiddenLabel>
      ) : null}
      <Stack
        direction="row"
        spacing={0.75}
        flexWrap="wrap"
        useFlexGap
        role="radiogroup"
        aria-labelledby={labelId || undefined}
        aria-label={labelId ? undefined : label}
      >
        {options.map((opt) => {
          const selected = opt.value === current;
          const palette = STATUS_CHIP_PALETTES[opt.value];
          return (
            <AccessStatusOptionButton
              key={opt.value}
              type="button"
              size="small"
              disabled={disabled}
              role="radio"
              aria-checked={selected}
              onClick={() => onChange(opt.value)}
              $selected={selected}
              $palette={palette}
            >
              {opt.label}
            </AccessStatusOptionButton>
          );
        })}
      </Stack>
    </AccessStatusSelectRoot>
  );
};

AccessStatusSelect.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  label: PropTypes.string,
  labelId: PropTypes.string,
};

AccessStatusSelect.defaultProps = {
  value: "",
  disabled: false,
  labelId: undefined,
};

export default AccessStatusSelect;
